
import { DOMAINS } from "./constants";
export const getUserSlug = () => window.location.href.match(/@([a-z0-9-]+)/)[1];

export const fallbackImage = "https://assets.adsttc.com/doodles/flat/logo-white-isotype.svg";

export const getPath = (entity = {}, site = "us") => {
  if (!Object.keys(entity).length) {
    return null;
  }
  const { original_id: originalId, slug, category } = entity;
  const appendSite = site !== "us" ? `/${site}` : ""; // For us, we don't show the site on the path

  const entities = {
    company: `${appendSite}/companies/${originalId}/${slug}`,
    office: `${appendSite}/office/${slug}`,
    photographer: `${appendSite}/photographer/${slug}`,
    author: `${appendSite}/author/${slug}`,
    profile: `${appendSite}/author/${slug}`,
    category: `/search${appendSite}/projects/categories/${slug}`,
    product_category: `/search${appendSite}/products/categories/${slug}`,
    landing: `${appendSite}/${slug}`,
    tag: `${appendSite}/tag/${slug}`
  };

  return entities[category];
};

export const generateEntitiesUrl = (entity = {}, site) => {
  if (!Object.keys(entity).length) {
    return null;
  }

  const domain = DOMAINS[site];
  const subdomain = "www";
  const path = getPath(entity, site);

  return `https://${subdomain}.${domain}${path}`;
};

export const setItemsInLocalStorage = (key, value) => {
  if (!key || !value) {
    return false;
  }
  return sessionStorage.setItem(key, value);
};

export const getItemFromLocalStorage = key => key && sessionStorage.getItem(key);
export const clearItemsFromLocalStorage = (keys = []) =>
  !!keys.length && keys.forEach(key => sessionStorage.removeItem(key));

export const scrollXIfNeeded = element => {
  const parent = element.parent;
  if (!parent) {
    return;
  }

  const { offsetLeft: elOffsetLeft, clientWidth } = element;
  const { offsetLeft: parentOffsetLeft, scrollLeft: parentScrollLeft, clientWidth: parentClientWidth } = parent;

  const parentComputedStyle = window.getComputedStyle(parent, null);
  const parentBorderLeftWidth = parseInt(parentComputedStyle.getPropertyValue("border-left-width"));
  const overLeft = elOffsetLeft - parentOffsetLeft < parentScrollLeft;
  const overRight =
    (elOffsetLeft - parentScrollLeft + clientWidth - parentBorderLeftWidth) >
    (parentScrollLeft + parentClientWidth);

  if (overLeft || overRight) {
    const scrollLeft = elOffsetLeft - parentOffsetLeft - parentClientWidth / 2 - parentBorderLeftWidth +
      clientWidth / 2;
    parent.scrollTo({
      left: scrollLeft,
      behavior: "smooth"
    });
  }
};

export const sendClickEventToInsights = ({ category, label, value, version = "", action = "click-result" }) => {
  window.adInsights.e(category, action, label, value, version);
};

export const sendAnalyticsEvent = (event, callback) => {
  if (!window.ga) { return; }
  const eventType = event.type || "event";
  const category = event.category || "";
  const action = event.action || "";
  const label = event.label || "";
  window.ga("send", eventType, category, action, label, { hitCallback: callback });
};

export const sendTracking = (info) => {
  window.dataLayer.push({
    event: "custom_event",
    type: "click",
    internalType: "onclick",
    dimensions: {
      category: info.category,
      action: info.action,
      label: info.label,
      value: "",
      dim1: info.value,
      dim2: info.href ?? ""
    }
  });
};

export function debounce (func, delay) {
  let timer;

  return function (...args) {
    const context = this;
    clearTimeout(timer);

    timer = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}

export function throttle (callback, delay) {
  let timeout;

  return (...args) => {
    if (timeout !== undefined) {
      return;
    }

    timeout = setTimeout(() => {
      timeout = undefined;
    }, delay);

    return callback.apply(this, args);
  };
}

export function isSubscriptionSite (site) {
  return site === "us";
}
